import { QSetReviewStatusTag } from '@exam-management/components';
import type { SearchOwnedAndAssignedTasksQuery } from '@exam-management/graphql';
import { EllipsisText, type GridColDef } from '@shared/components';
import { formatDate } from '@shared/utils';

export type QSetReviewTask = Pick<
  SearchOwnedAndAssignedTasksQuery['wflSearchOwnedAndAssignedTasks']['tasks'][number],
  | 'dueDate'
  | 'name'
  | 'status'
  | 'code'
  | 'id'
  | 'assignee'
  | 'assigner'
  | 'updatedAt'
  | 'parentTask'
  | 'currentWorkflowStep'
  | 'metadata'
  | 'taskEntities'
>;

export const columns: GridColDef<QSetReviewTask>[] = [
  {
    field: 'code',
    headerName: 'Task ID',
    width: 100,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText>{params.row.code}</EllipsisText>;
    },
  },
  {
    field: 'name',
    headerName: 'Task Name',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText>{params.row.name ?? params.row.parentTask?.name}</EllipsisText>;
    },
  },
  {
    field: 'courseName',
    headerName: 'Course Name',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      if (params.row.metadata.__typename === 'TaskMetadataWithExamCourse') {
        return <EllipsisText>{params.row.metadata.examCourse.name}</EllipsisText>;
      }
      return '-';
    },
  },
  {
    field: 'qsetCount',
    headerName: 'QSet',
    width: 68,
    sortable: false,
    renderCell: (params) => {
      const qsetCount =
        params.row.metadata.__typename === 'TaskMetadataWithExamCourse'
          ? params.row.metadata.subtaskEntityQuantity
          : 0;
      return qsetCount;
    },
  },
  {
    field: 'reviewer',
    headerName: 'Reviewer',
    width: 240,
    sortable: false,
    renderCell: (params) => {
      const fullName = `${params.row.assignee.firstname} ${params.row.assignee.lastname}`;

      return <EllipsisText>{fullName}</EllipsisText>;
    },
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    width: 120,
    sortable: false,
    valueFormatter: (params) => {
      return formatDate(params.value);
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    sortable: false,
    renderCell: (params) => {
      return <QSetReviewStatusTag status={params.row.currentWorkflowStep.code} />;
    },
  },
];
